function selectDefinedValue(...values) {
  return values.find((value) => value !== undefined)
}

export default function mergeCharacterCombatantFatigueUpdate({
  existingCombatant,
  storeCombatant,
  incomingCombatant,
}) {
  const baseCombatant = existingCombatant || storeCombatant || {}

  return {
    ...baseCombatant,
    id: selectDefinedValue(incomingCombatant?.id, baseCombatant.id),
    slug: selectDefinedValue(incomingCombatant?.slug, baseCombatant.slug),
    name: selectDefinedValue(incomingCombatant?.name, baseCombatant.name),
    fatigue: selectDefinedValue(incomingCombatant?.fatigue, baseCombatant.fatigue),
    sr: selectDefinedValue(incomingCombatant?.sr, baseCombatant.sr),
    sr_adj: selectDefinedValue(incomingCombatant?.sr_adj, baseCombatant.sr_adj),
    dex: selectDefinedValue(incomingCombatant?.dex, baseCombatant.dex),
    ca: selectDefinedValue(incomingCombatant?.ca, baseCombatant.ca),
    status: selectDefinedValue(incomingCombatant?.status, baseCombatant.status),
  }
}
